"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** По клику открывается обучающая модалка */
const autoActionSurveyTutorialModalButtonClick = ({ vacancyId, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("auto_action_survey_tutorial_modal", { vacancyId, ...analyticsParams });
exports.default = autoActionSurveyTutorialModalButtonClick;
